import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class RefreshTokenService {
  private authService = inject(AuthService);

  private RefreshTokenTimerMs = 10 * 60 * 1000;

  keepTokenAlive() {
    setInterval(() => {
      const authToken = this.authService.getToken();
      if (authToken) {
        this.authService.refreshToken(authToken.refresh_token)
          .subscribe(result => {
            this.authService.setToken(result);
          });
      }
    }, this.RefreshTokenTimerMs);
  }
}
